const CONSUMPTION_RULES = {
  required: true,
  numeric: true,
  maxlength: 7,
  minvalue: 2,
  messages: {
    minvalue: 'Mindestverbrauch ist 2 kWh',
  },
};
export const CALCULATOR_POWER_SCHEMA = {
  postcode: {
    required: true,
    numeric: true,
    length: 5,
  },
  city: {
    required: true,
    obtainedFromPostCode: true,
    messages: {
      required: '',
    },
  },
  consumption: CONSUMPTION_RULES,
  consumption_industry: CONSUMPTION_RULES,
};

export const CALCULATOR_GAS_SCHEMA = {
  postcode: {
    required: true,
    numeric: true,
    length: 5,
  },
  city: {
    required: true,
    obtainedFromPostCode: true,
    messages: {
      required: '',
    },
  },
  consumption: CONSUMPTION_RULES,
  consumption_industry: CONSUMPTION_RULES,
};

export const CALCULATOR_HEATFLOW_SCHEMA = {
  postcode: {
    required: true,
    numeric: true,
    length: 5,
  },
  city: {
    required: true,
    obtainedFromPostCode: true,
    messages: {
      required: '',
    },
  },
  consumption_ht: CONSUMPTION_RULES,
  consumption_nt: CONSUMPTION_RULES,
  countingprocedure: {
    required: true,
  },
  heatflow_devicetype: {
    required: true,
    messages: {
      required:
        'Pflichtfeld. Du benötigst eine Wärmepumpe für unseren Wärmestrom.',
    },
  },
};
